import React from "react";
import { cls } from "../ui";

/** Tyler-style contextual ribbon — labeled groups of small icon+label actions with a caption under each group. */
export const Ribbon = ({ children, testId, right }) => (
  <div className="ent-ribbon no-print" data-testid={testId}>
    {children}
    {right && <div className="ml-auto self-center flex items-center gap-1 pr-1">{right}</div>}
  </div>
);

export function RibbonGroup({ caption, children, testId }) {
  const kids = React.Children.toArray(children).filter(Boolean);
  if (!kids.length) return null;
  return (
    <div className="ent-ribbon-group" data-testid={testId}>
      <div className="ent-ribbon-row">{kids}</div>
      <div className="ent-ribbon-caption">{caption}</div>
    </div>
  );
}

export const RibbonBtn = ({ icon: Icon, children, onClick, tone, disabled, title, testId, active }) => (
  <button type="button" className={cls("ent-ribbon-btn", tone && `ent-ribbon-${tone}`, active && "ent-ribbon-active")} onClick={onClick} disabled={disabled} title={title || (typeof children === "string" ? children : undefined)} data-testid={testId}>
    {Icon && <Icon className="w-3.5 h-3.5 shrink-0" />}<span className="truncate">{children}</span>
  </button>
);
